import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IState, draftAdapter, draftFeatureKey } from './draft.reducers';
import { createQueryParamsWithPagination } from '../../../shared/utils';
import { IDraftFilter } from './draft.interface';

const selectFeature = createFeatureSelector<IState>(draftFeatureKey);

const { selectAll } = draftAdapter.getSelectors(selectFeature);

const selectError = createSelector(selectFeature, (state) => state.error);

const selectLoading = createSelector(selectFeature, (state) => state.loading);

const selectPreview = createSelector(selectFeature, (state) => state.preview);

const selectLastVerdict = createSelector(
	selectFeature,
	(state) => state.lastVerdict,
);

const selectDraftFilter = createSelector(
	selectFeature,
	(state) => state.filter,
);

const selectDraftFilterRequest = createSelector(selectDraftFilter, (state) =>
	createQueryParamsWithPagination<IDraftFilter>(state),
);

export const DraftSelectors = {
	selectAll,
	selectError,
	selectLoading,
	selectPreview,
	selectLastVerdict,
	selectDraftFilter,
	selectDraftFilterRequest,
};
